/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { wordTimingSchema } from '../shared/word-timing-schema';

export const getDefinitionAudioCachedV1ResultSchema = z.discriminatedUnion('exists', [
  z.object({ exists: z.literal(false) }),
  z.object({
    exists: z.literal(true),
    value: z.object({
      audioUrl: z.string(),
      wordTimings: z.array(wordTimingSchema).optional(),
    }),
  }),
]);

export type IGetDefinitionAudioCachedV1Result = z.infer<
  typeof getDefinitionAudioCachedV1ResultSchema
>;

export const getDefinitionAudioCachedV1ResponseSchema = createApiResponseSchema(
  getDefinitionAudioCachedV1ResultSchema,
) as z.ZodSchema<IAPI<IGetDefinitionAudioCachedV1Result>>;

export type IGetDefinitionAudioCachedV1Response = IAPI<IGetDefinitionAudioCachedV1Result>;
